/* unplugin-vue-components disabled */import { render } from "./PdpDisplay.vue?vue&type=template&id=6d9aff59&ts=true"
import script from "./PdpDisplay.vue?vue&type=script&lang=ts"
export * from "./PdpDisplay.vue?vue&type=script&lang=ts"

import "./PdpDisplay.vue?vue&type=style&index=0&id=6d9aff59&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__